import Analytics from '~analytics';
import facebookPixelPlugin from '~packs/analytics/src/fb-pixel';
import googleAnalyticsPlugin from '~packs/analytics/src/google-analytics';
import googleEcommercePlugin from '~packs/analytics/src/google-ecommerce';
import posthogPlugin from '~packs/analytics/src/posthog-analytics';

// NOTE: Deliberately no module-level side effects. Building the Analytics
// singleton at import time made this module unsafe under Vite/rolldown code
// splitting: the shared chunk could end up in an import cycle with an
// entrypoint (e.g. purchase.js), and a top-level `const analytics = ...` sits
// in the temporal dead zone while that cycle resolves. A consumer reading
// `analytics` mid-cycle then got `undefined` and threw, aborting the whole
// entrypoint before Alpine ever started (see PN-289). A hoisted accessor
// function is safe to call at any point during evaluation, so we build the
// singleton lazily on first use instead.
let analyticsInstance;

function getAnalytics() {
  if (analyticsInstance) return analyticsInstance;

  analyticsInstance = Analytics({
    app: 'pay-hammer',
    version: 1,
    plugins: [
      facebookPixelPlugin({
        id: pnEnv.FACEBOOK_ID,
        dataProcessingOptions: {
          method: ['LDU'],
          country: 0,
          state: 0,
        },
      }),
      googleAnalyticsPlugin({
        measurementIds: [pnEnv.GOOGLE_ANALYTICS_V4_ID],
      }),
      googleEcommercePlugin(), // configured via google analytics plugin
      posthogPlugin({
        apiKey: pnEnv.POSTHOG_API_KEY,
      }),
    ],
  });

  // NOTE: Used by some simple Alpine components that read the global directly.
  window.analytics = analyticsInstance;

  return analyticsInstance;
}

export { getAnalytics };
